<template>
<div>
  <div class="bg-primary-lightest py-10">
    <div class="static-container text-center sm:text-left">
      <h2 v-if="articleIsReady" class="text-3xl sm:text-6xl font-bold">
        {{ item.title }}
      </h2>
      <p v-if="articleIsReady" class="text-grey-darkest mt-3 mx-auto text-lg sm:mt-4">
        {{ item.created_at.datetime_at }}
      </p>
      <p v-if="articleIsReady && item.visible" class="text-grey-darkest mt-3 mx-auto text-base sm:mt-4">
        <router-link :to="{ name: 'blog-list' }" class="underline">&larr; К списку статей</router-link>
      </p>
    </div>
  </div>
  <div class="static-container mt-10">
    <div v-if="articleIsReady" class="prose mb-4 max-w-full px-4 sm:px-0" v-html="item.body"></div>
  </div>
</div>
</template>

<script>
import axios from '@/zenky'
import InjectsSeo from '@/mixins/InjectsSeo'
import { mapGetters } from 'vuex'

export default {
  mixins: [InjectsSeo],

  props: {
    shortId: {
      required: true,
      type: String,
    },
    slug: {
      required: true,
      type: String,
    },
    article: {
      required: false,
      type: Object,
      default: () => null,
    },
  },

  metaInfo() {
    if (!this.articleIsReady) {
      return this.getMetaInfoFromSettings(this.blogSeo)
    }

    return {
      title: this.getFullPageTitle(this.item.title),
      meta: [
        { name: 'description', content: this.item.intro },
      ],
    }
  },

  mounted() {
    if (this.article && this.article.short_id && this.article.short_id === this.shortId) {
      this.item = this.article
    } else {
      this.loadArticle()
    }
  },

  computed: {
    ...mapGetters({
      blogSeo: 'settings/blogSeo',
    }),

    articleIsReady() {
      return !!this.item.id
    },
  },

  methods: {
    loadArticle() {
      if (this.articleIsLoading) {
        return
      }

      this.articleIsLoading = true

      axios.get(`articles/${this.shortId}?with=media,category`)
        .then(({ data }) => {
          this.articleIsLoading = false
          this.item = data.data
        })
        .catch(err => {
          this.articleIsLoading = false
          this.articleDoesNotExists = true
        })
    }
  },

  data() {
    return {
      articleIsLoading: false,
      articleDoesNotExists: false,
      item: {},
    }
  }
}
</script>

<style lang="less">
@import "~@/assets/less/components/blog-articles-header";

.blog-article-item-content {
  @apply my-8;

  p {
    @apply mb-4 text-lg leading-26;
  }
}
</style>
